import { ObservationItem } from '@liza/ui/components/records/ObservationItem';
import type { WithId } from '@medplum/core';
import type { Observation } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { useCodeDisplay } from '../../hooks/useCodeDisplay';
import { groupObservations } from '../../utils/observation';

export type SurveysListProps = {
  surveys: WithId<Observation>[];
  onSelectSurvey?: (identifier: string) => void;
  selectedSurveyIdentifier?: string;
};

export const SurveysList = ({
  surveys,
  onSelectSurvey,
  selectedSurveyIdentifier,
}: SurveysListProps): React.ReactElement => {
  const { t } = useTranslation('records');
  const { displayFor } = useCodeDisplay();

  const groupedSurveys = groupObservations(surveys).map((g) => ({ ...g, name: displayFor(g.latest.code) }));

  if (groupedSurveys.length === 0) {
    return (
      <div className="mx-auto w-full max-w-4xl">
        <p className="py-8 text-center text-sm text-muted-foreground">{t('noSurveysFound')}</p>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-4xl">
      {groupedSurveys.map((groupedSurvey) => (
        <ObservationItem
          key={groupedSurvey.identifier}
          {...groupedSurvey}
          onSelect={onSelectSurvey}
          selected={selectedSurveyIdentifier === groupedSurvey.identifier}
        />
      ))}
    </div>
  );
};
